export interface UserInterface {
  id: string;
  firstName: string;
  lastName: string;
  roles: string[];
  username: string;
  title: string;
  voipPhoneNumber?: string | null;
  voipUserId?: number | null;
}

export class User {
  id: string;
  firstName: string;
  lastName: string;
  roles: string[];
  username: string;
  title: string;
  voipPhoneNumber?: string | null;
  voipUserId?: number | null;

  constructor(data: UserInterface) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.roles = data.roles;
    this.username = data.username;
    this.title = data.title;
    this.voipPhoneNumber = data.voipPhoneNumber;
    this.voipUserId = data.voipUserId;
  }
}
